import React from "react";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { 
  X, 
  Building2, 
  MapPin, 
  Phone, 
  Mail, 
  Users, 
  Euro, 
  Award, 
  BookOpen, 
  Star,
  Target,
  Briefcase
} from "lucide-react";

const ScopriDiPiuModal = ({ isOpen, onClose, agenzia }) => {
  if (!isOpen || !agenzia) return null;

  // Mock data per i dettagli aggiuntivi (in futuro verranno dal backend)
  const dettagliAggiuntivi = {
    numeroAgentiAttivi: Math.floor(Math.random() * 20) + 5,
    commissioneRange: "40% - 60%",
    vantaggi: [
      "Formazione continua gratuita",
      "Supporto marketing completo", 
      "Lead generation qualificati",
      "Sistema CRM avanzato"
    ],
    corsiFormazione: [
      "Corso base agente immobiliare",
      "Tecniche di vendita avanzate",
      "Marketing digitale immobiliare",
      "Negoziazione e closing"
    ],
    descrizione: "Agenzia immobiliare leader nella zona con oltre 10 anni di esperienza. Specializzata in vendite e locazioni residenziali, con un team di professionisti qualificati e un approccio innovativo al mercato immobiliare."
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" style={{overflow: 'hidden'}}>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-3xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-gray-100 flex flex-col" style={{minHeight: '400px'}}>
        {/* Header */}
        <div className="sticky top-0 bg-white rounded-t-3xl border-b border-gray-100 p-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center">
              <Building2 className="w-6 h-6 text-white" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">
                {agenzia.agenzia_nome}
              </h2>
              <p className="text-sm text-gray-600">Scopri tutti i dettagli</p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="rounded-full p-1 h-8 w-8 hover:bg-gray-100"
          >
            <X className="w-5 h-5" />
          </Button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Informazioni Base */}
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex items-center gap-3">
                <MapPin className="w-5 h-5 text-blue-600" />
                <div>
                  <p className="text-sm text-gray-600">Sede Principale</p>
                  <p className="font-semibold text-gray-900">{agenzia.agenzia_zona || "Roma Centro"}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Building2 className="w-5 h-5 text-blue-600" />
                <div>
                  <p className="text-sm text-gray-600">Tipologia</p>
                  <p className="font-semibold text-gray-900">{agenzia.agenzia_tipo || "Franchising"}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Users className="w-5 h-5 text-blue-600" />
                <div>
                  <p className="text-sm text-gray-600">Agenti Attivi</p>
                  <p className="font-semibold text-gray-900">{dettagliAggiuntivi.numeroAgentiAttivi} professionisti</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Euro className="w-5 h-5 text-blue-600" />
                <div>
                  <p className="text-sm text-gray-600">Range Provvigioni</p>
                  <p className="font-semibold text-gray-900">{dettagliAggiuntivi.commissioneRange}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contatti */}
          <div className="bg-gray-50 rounded-2xl p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <Phone className="w-5 h-5 text-gray-600" />
              Contatti
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {agenzia.telefono_referente && (
                <div className="flex items-center gap-3">
                  <Phone className="w-4 h-4 text-gray-500" />
                  <span className="text-gray-700">{agenzia.telefono_referente}</span>
                </div>
              )}
              {agenzia.contatto_referente && (
                <div className="flex items-center gap-3">
                  <Mail className="w-4 h-4 text-gray-500" />
                  <span className="text-gray-700">{agenzia.contatto_referente}</span>
                </div>
              )}
            </div>
          </div>

          {/* Descrizione Agenzia */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <Building2 className="w-5 h-5 text-gray-600" />
              Chi Siamo
            </h3>
            <p className="text-gray-700 leading-relaxed">
              {dettagliAggiuntivi.descrizione}
            </p>
          </div>

          {/* Vantaggi e Benefici */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <Award className="w-5 h-5 text-gray-600" />
              Vantaggi per il Candidato
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {dettagliAggiuntivi.vantaggi.map((vantaggio, index) => (
                <div key={index} className="flex items-center gap-3 bg-green-50 rounded-xl p-3">
                  <Star className="w-5 h-5 text-green-600 flex-shrink-0" />
                  <span className="text-gray-700 text-sm">{vantaggio}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Corsi di Formazione */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <BookOpen className="w-5 h-5 text-gray-600" />
              Percorsi di Crescita e Formazione
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {dettagliAggiuntivi.corsiFormazione.map((corso, index) => (
                <div key={index} className="flex items-center gap-3 bg-purple-50 rounded-xl p-3">
                  <Target className="w-5 h-5 text-purple-600 flex-shrink-0" />
                  <span className="text-gray-700 text-sm">{corso}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Match Score */}
          <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-2xl p-6 text-white">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-semibold mb-2">Compatibilità con te</h3>
                <p className="text-green-100 text-sm">
                  Basato su zona, esperienza e preferenze
                </p>
              </div>
              <div className="text-right">
                <div className="text-3xl font-bold">
                  {agenzia.match_percentage || "85"}%
                </div>
                <p className="text-green-100 text-sm">Match</p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3 pt-4">
            <Button
              onClick={onClose}
              variant="outline"
              className="flex-1 rounded-xl border-gray-300 hover:bg-gray-50"
            >
              Chiudi
            </Button>
            <Button
              className="flex-1 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-xl font-medium"
              onClick={() => {
                onClose();
                // Qui si potrebbe aprire il modal "Richiedi Colloquio"
              }}
            >
              <Briefcase className="w-4 h-4 mr-2" />
              Richiedi Colloquio
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScopriDiPiuModal;